(function() {
    'use strict';

    angular
        .module('app.layout')
        // .filter('filterLocationsL', filterLocationsL)
        .directive('pickupList', pickupList);


    /* @ngInject */
    function pickupList($q, $window,$sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'pickup-list.tpl',
            controller: pickupListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                locs: '=',
                type: '@'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.filteredLocations = null;
            scope.vm.locations = [];
            scope.vm.activeLocation = null;
            scope.vm.searchText = null;
            scope.vm.showMobileInfoOverlay = false;
            scope.vm.states = [];
            var sh = 'no-state';
            angular.forEach(scope.vm.locs, function(e) {
                if(scope.$root.project_has_opt('siteInventory') && !e.inventory) {
                    return false;
                }

                if (
                    (scope.$root.project_has_opt('privSite'))  ||
                    ((scope.vm.type == 'private') && e.private) ||
                    ((scope.vm.type != 'private') && !e.private)
                ) {
                    var s = e.state;
                    if (s !== sh) {
                        scope.vm.states.push(s);
                        sh = s;
                    }

                    scope.vm.locations.push({
                        data: e,
                        show: !scope.$root.project_has_opt('privSite') || (e.private ? false : true)
                    });
                }
            });
            scope.vm.states.sort();


            if (scope.vm.data.value) {
                scope.activateLocation(true);
            }
            // do nothing if api key missing in maps settings


            scope.vm.resetSearch = function(event) {
                event.stopPropagation();
                scope.vm.searchText = '';
                element.find("#pick-locations-list").scrollTop(0);
            };

            scope.vm.getHours = function(params, ends) {
                var output = scope.$root.formatHours(params, ends);
                return $sce.trustAsHtml(output === '' ? '-' : output);
            };

            scope.vm.selectLocation = function(event, loc) {
                if (loc.passive) {
                    return;
                }
                event.stopPropagation();
                if(scope.vm.activeLocation === null || scope.vm.activeLocation.id !== loc.data.id) {
                    scope.vm.activeLocation = loc.data;
                    var emitData = {
                        id: loc.data.id,
                        dt: loc.data.dt,
                        title: loc.data.title,
                        'site-no': loc.data['site-no']
                    };
                    if (scope.vm.type != 'private') {
                        emitData.address =  loc.data.address;
                        emitData.hours =  scope.vm.getHours(loc.data['pick-up-hours']);
                        emitData.hoursRaw = loc.data['pick-up-hours'];
                    }

                    if ((scope.vm.type == 'private') && scope.$root.project_has_opt('privSiteCode')) {
                        scope.vm.privCodeModal = true;
                        return;
                    }
                    scope.$emit("location-changed", emitData);
                }
            };

            function scrollActiveListItem() {
                var $list = element.find("#pick-locations-list");
                var items = $list.find(".pickup-locations-list-item");
                var scrollOffset = 0;

                angular.forEach(items, function(item) {
                    var $item = $(item);

                    if ($item.attr('id') === scope.vm.activeLocation.id) {
                        $list.scrollTop(scrollOffset);
                    } else {
                        scrollOffset += $item.height();
                    }
                });
            }

        }
    }

    /* @ngInject */
    function pickupListController ($scope, $sce, $http) {
        $scope.getInventory = function(inventory) {
            var r = '';
            if (inventory) {
                inventory.forEach(function(e) {
                    r +=  e.name + ': ' + e.inStock + ' available' + '<br>';
                });
            }
            return $sce.trustAsHtml(r);
        };

        // $scope.$on('site-inventory-filter', function(e, pies) {
        //     var noSites = (((Object.values(pies).length == 1)  && (Object.values(pies)[0]['short-name'] == 'PFC')) || (Object.values(pies).length == 0)) ? true : false;
        //     var poor = 0;
        //     $scope.vm.locations.forEach(function(l) {
        //         if (l.data.inventory) {
        //             l.data.inventory.forEach(function(e) {
        //                 if (pies[e.pie_id.value] && (pies[e.pie_id.value].value > e.inStock)) {
        //                     poor++;
        //                     return;
        //                 }
        //             });
        //         }
        //     });
        //     if ((poor == $scope.vm.locations.length)  || noSites) {
        //         if (angular.element('[field-key="site"] > div').hasClass('active')) {
        //             setTimeout(function() {
        //                 angular.element('[field-key="site"] button.accordion-toggle').click();
        //                 $scope.$root.blockTab = 'site';
        //             }, 10);
        //         } else {
        //             $scope.$root.blockTab = 'site';
        //         }
        //         $scope.$emit('location-changed', null);
        //     } else {
        //         $scope.$root.blockTab = '';
        //     }
        // });

        $scope.activateLocation = function(reset) {
            $scope.vm.activeLocation = null;
            $scope.vm.locations.forEach(function(e) {
                if (e.data.id == $scope.vm.data.value) {
                    e.show = true;
                    $scope.vm.activeLocation = e.data;
                } else if (reset && $scope.$root.project_has_opt('privSite')) {
                    e.show =  e.data.private ? false : true;
                }
            });
            $scope.filterLocations();
        };

        $scope.$watch('vm.searchText', function(v) {
            $scope.filterLocations(v);
        });

        $scope.filterLocations =  function(v) {
            $scope.vm.filteredLocations = $scope.$root.project_has_opt('neighborhood') ? {} : [];
            $scope.vm.noResults = false;
            // function checkAndPickValue(field, key) {
            //     if (angular.isObject(field) && angular.isString(field.value)) {
            //         return field.value.toLocaleLowerCase();
            //     }
            //     return '';
            // }

            var queryLower = !v ? '' : v.toLocaleLowerCase();

            $scope.vm.locations.filter(function(l) {
                var r = true;
                if (queryLower) {
                    r = (l.data['site-no'].toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        // (l.data.city.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        (l.data.address.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        (l.data.title.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        (l.data.nh.toLocaleLowerCase().indexOf(queryLower) !== -1) ||
                        (l.data.state.toLocaleLowerCase().indexOf(queryLower) !== -1);
                }
                var isDT = l.data.dt;
                return r && l.show && ((isDT && ($scope.vm.type == 'dt')) || (!isDT && ($scope.vm.type != 'dt')));
            }).forEach(function(l) {
                if ($scope.$root.project_has_opt('neighborhood')) {
                    if ($scope.$root.safeChain(l, 'data, state')) {
                        if (!$scope.vm.filteredLocations[l.data.state]) {
                            $scope.vm.filteredLocations[l.data.state] = [];
                        }
                        $scope.vm.filteredLocations[l.data.state].push(l);
                    }
                } else {
                    $scope.vm.filteredLocations.push(l);
                }
            });
            if ($scope.$root.project_has_opt('neighborhood')) {
                $scope.vm.states.forEach(function(s) {
                    if (typeof $scope.vm.filteredLocations[s] != 'undefined') {
                        $scope.vm.filteredLocations[s].sort(function(a, b) {
                            return a.data.nh > b.data.nh ? 1 : 0;
                        });
                    }
                });
            }

            $scope.vm.noResults =  $scope.$root.project_has_opt('neighborhood') ? Object.keys($scope.vm.filteredLocations).length === 0 : $scope.vm.filteredLocations.length === 0 ;
        };

        $scope.$on('pickup-location-changed-external', function(e, reset) {
            $scope.activateLocation(reset);
        });

        $scope.privModalClose = function() {
            $scope.vm.privCodeModal = false;
            $scope.vm.privCodeError  = '';
            $scope.vm.site_code  = '';
        };

        $scope.checkPrivCode = function() {
            if (!$scope.vm.site_code || $scope.vm.site_code == '') {
                $scope.vm.privCodeError = 'Site code cannot be empty';
                return;
            }
            if ($scope.vm.activeLocation) {
                $scope.vm.tempActive = Object.assign({}, $scope.vm.activeLocation);
            }
            $http.post(ajaxurl, {
                action: 'pie_action',
                method: 'check_site_code',
                nonce: $scope.$root.stats.nonce,
                params: {
                    site_id: $scope.vm.tempActive.id,
                    site_code: $scope.vm.site_code
                }
            }).then(function(response) {
                if (!response.data.result) {
                    $scope.vm.privCodeError = response.data.message;
                    $scope.vm.activeLocation = null;
                } else {
                    $scope.vm.activeLocation = $scope.vm.tempActive;
                    var emitData = {
                        id: $scope.vm.activeLocation.id,
                        title: $scope.vm.activeLocation.title,
                        'site-no': $scope.vm.activeLocation['site-no'],
                        site_code: $scope.vm.site_code
                    };
                    $scope.$emit("location-changed", emitData);
                    $scope.privModalClose();
                }
            });
        };
    }
})();